import { useNavigate } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";
import { getProfile } from "@/lib/storage";

export default function MatchingGate({ children }) {
  const navigate = useNavigate();
  const profile = getProfile();

  if (profile?.usageMode !== "solo") return children;

  return (
    <div className="px-6 sm:px-10 py-16 max-w-3xl mx-auto">
      <div className="hm-card p-10 rounded-md text-center" data-testid="matching-gate">
        <Lock className="w-8 h-8 text-[#F59E0B] mx-auto mb-5" strokeWidth={1.25} />
        <h2 className="font-serif-editorial font-light text-3xl leading-tight mb-3">
          Partner matching is one step away.
        </h2>
        <p className="text-[#A1A1AA] font-light max-w-xl mx-auto mb-8">
          You can only start matching with accountability partners once you choose to use the
          Partners or Group mode and finish the full onboarding details.
        </p>
        <button
          type="button"
          onClick={() => navigate("/onboarding?edit=1")}
          data-testid="matching-gate-edit"
          className="hm-btn-primary inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-semibold"
        >
          Edit your profile <ArrowRight className="w-4 h-4" strokeWidth={1.75} />
        </button>
      </div>
    </div>
  );
}
